import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {IGeoNearSearch} from '../../shared/components/near-regions-search/near-regions-search.component';

export interface IOptions {
  category: any[];
  regions: any[];
  ages: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private dataSubject = new BehaviorSubject<any>( {} as any );
  currentData = this.dataSubject.asObservable();
  data$: Observable<any>;
  cities$: Observable<any[]>;
  ages$: Observable<any[]>;
  categories$: Observable<any[]>;

  constructor(private apiService: ApiService) {
    this.getData();
  }

  getData() {
    this.data$ = this.apiService.get('/settings/option')
      .pipe(res => {
        this.dataSubject.next(res);
        return res;
      });
  }

  setData(data: IOptions) {
    this.dataSubject.next(data);
  }

  getCities(): Observable<any> {
    return this.cities$.pipe(res => res);
  }

  getAges(): Observable<any> {
    return this.ages$.pipe(res => res);
  }

  getCategories(): Observable<any> {
    return this.categories$.pipe(res => res);
  }

  getAll() {
    return this.data$.pipe(res => res);
    // return this.dataSubject$.value;
  }

  getNearByRegions(options: IGeoNearSearch): Observable<any> {
    return this.apiService.post('/settings/near-regions', options);
  }
}
